import ReportTypeScreen from "../../Components/Reports/ReportTypeScreen";

function ReportedPicturePosts() {
  return <ReportTypeScreen reportType="picture_post" />;
}

export default ReportedPicturePosts;
